// Global Instructions Rule Applied!

import {
  fetchCompanyById,
  createCompany,
  updateCompany
} from '../../../app_modules/companies/services/companiesService.ts'
import { setCompanies, updateCompanyRecord, addCompany } from './company_actions.ts'
import { AccountRecord } from '../../data_models/account_record.ts'
import { AppDispatch } from '../../store.ts'

/**Fetches a company by ID. */
const fetchCompanyByIdService = async (
  companyId: string | number,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: AccountRecord | null; error?: string }> => {
  try {
    const response = await fetchCompanyById(companyId, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    return { data: response.data as AccountRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch company'
    return { data: null, error: errorMessage }
  }
}

/**Creates a new company and dispatches addCompany action. */
export const createCompanyService = async (
  companyData: Record<string, any>,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: AccountRecord | null; error?: string }> => {
  try {
    const response = await createCompany(companyData, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    if (response.data) {
      dispatch(addCompany({ company: response.data as AccountRecord }))
    }

    return { data: response.data as AccountRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to create company'
    return { data: null, error: errorMessage }
  }
}

/**Updates an existing company and dispatches updateCompanyRecord action. */
export const updateCompanyService = async (
  companyId: string | number,
  companyData: Record<string, any>,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: AccountRecord | null; error?: string }> => {
  try {
    const response = await updateCompany(companyId, companyData, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    if (response.data) {
      const updatedCompany = response.data as AccountRecord
      const idString = companyId.toString()

      dispatch(
        updateCompanyRecord({
          companyId: idString,
          updates: updatedCompany
        })
      )
    }

    return { data: response.data as AccountRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to update company'
    return { data: null, error: errorMessage }
  }
}
